import { render } from "./Toggle.vue?vue&type=template&id=2a7bd34a"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"

import "./Toggle.vue?vue&type=style&index=0&id=2a7bd34a&lang=scss"
script.render = render

export default script